import { render, staticRenderFns } from "./BlogArticlesListPage.vue?vue&type=template&id=29079778&"
import script from "./BlogArticlesListPage.vue?vue&type=script&lang=js&"
export * from "./BlogArticlesListPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogArticlesListPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports